<section class="about px-8">
  <h2 class="text-2xl mt-8">
    Pojemniki do lad chłodniczych
  </h2>
  <p class="mt-8 mb-8">
    Odpowiednie wyłożenie towaru w pojemnikach ułatwia i zwiększa sprzedaż. Ważny jest również walor estetyczny, ponieważ klient często „kupuje oczami”. W naszej ofercie znajdują się pojemniki wykonane z najwyższej jakości materiałów - bardzo odpornych na uderzenia i na ścieranie. Pojemniki są łatwe do utrzymania w czystości i można je myć w zmywarkach. Dzięki temu ekspozycja żywności staje się prostsza i efektywniejsza.
  </p>
</section>